import { Maximize2 } from "lucide-react";
import { useState } from "react";

import AnalyticsChartToolbarButton from "../../AnalyticsChartToolbarButton";
import {
  ANALYTICS_GRAPH_FULLSCREEN_CHART_HEIGHT_CLASS,
  ANALYTICS_GRAPH_FULLSCREEN_DIALOG_CLASS,
} from "../../constants";

import AnalyticsMermaidDiagram from "./AnalyticsMermaidDiagram";

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

const AnalyticsMermaidDiagramCard = ({
  title,
  diagram,
  className,
}: {
  title: string;
  diagram: string;
  className?: string;
}) => {
  const [isFullscreenOpen, setIsFullscreenOpen] = useState(false);

  return (
    <>
      <div className={cn("rounded-lg border border-gray-100 bg-gray-50/50 p-4", className)}>
        <div className="mb-2 flex shrink-0 items-center justify-between gap-2">
          <h4 className="min-w-0 text-base font-semibold text-gray-900">{title}</h4>
          <AnalyticsChartToolbarButton
            ariaLabel="Open diagram fullscreen"
            icon={Maximize2}
            onClick={() => setIsFullscreenOpen(true)}
            tooltip="Open fullscreen"
          />
        </div>
        <AnalyticsMermaidDiagram diagram={diagram} />
      </div>

      <Dialog open={isFullscreenOpen} onOpenChange={setIsFullscreenOpen}>
        <DialogContent className={ANALYTICS_GRAPH_FULLSCREEN_DIALOG_CLASS}>
          <DialogHeader className="shrink-0 pr-8 text-left">
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
          <AnalyticsMermaidDiagram
            diagram={diagram}
            className={ANALYTICS_GRAPH_FULLSCREEN_CHART_HEIGHT_CLASS}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AnalyticsMermaidDiagramCard;
